module.exports = __webpack_public_path__ + "static/media/arrow6.391bf3ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/guide/arrow6.png
// module id = 1423
// module chunks = 10